export abstract class ChartConfigBase {
  /* Vilket språk som används, ex. 'sv' */
  public language: string;

  /* En sträng som kan parsas till datum av .net (med moment.js .format("YYYY-MM-DD")) */
  public startdat: string;
  
  /* En sträng som kan parsas till datum av .net (med moment.js .format("YYYY-MM-DD")) */
  public stopdat: string;

  /* Om "Visa för ett år bakåt" är valt */
  public currentYear: boolean;

  /* Rapportnamn som används för att ladda korrekt rapport på backend */
  public reportName: string;

  /* Gruppering för SQL */
  public grouping: string;

  /* URL-base till api (https://.....) */
  public abstract apiBaseUrl: string;

  /* URL för att hämta HighChartdatan på servern */
  public abstract highChartUrl: string;
  
  /* URL för att hämta tabelldatan på servern */
  public abstract tableUrl: string;

  /* Bredden på grafen i pixlar */
  public chartWidth: number;

  /* Höjden på grafen i pixlar */
  public chartHeight: number;

  /* Förutbestämda färger som ska användas i graferna */
  public chartColors: string[];
  
  /* Vridningsgrad för labels på xAxel */
  public xAxisLabelRotation: number;

  /* Verifierar datan i config-objektet
   * Objektet får ej användas om false */
  public configIsValid(): boolean {
    return this.highChartUrl && this.highChartUrl.length > 0 && this.tableUrl && this.tableUrl.length > 0;
  }
}
